/**
 * Exclude Filter
 * Filters out text that should not be translated
 * Mirrors PHP's HtmlTranslator logic
 */

export interface ExcludePatterns {
  emails: boolean;
  urls: boolean;
  numbers: boolean;
  phones: boolean;
}

const DEFAULT_PATTERNS: ExcludePatterns = {
  emails: true,
  urls: true,
  numbers: true,
  phones: true,
};

// Regex patterns matching PHP's HtmlTranslator
const PATTERNS = {
  email: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  url: /^(https?:\/\/|www\.)[^\s]+$/i,
  number: /^[\d\s.,+-]+$/,
  phone: /^[+\d][\d\s().-]{6,}$/,
};

export class ExcludeFilter {
  private patterns: ExcludePatterns;
  private minTextLength: number;

  constructor(patterns: Partial<ExcludePatterns> = {}, minTextLength = 2) {
    this.patterns = { ...DEFAULT_PATTERNS, ...patterns };
    this.minTextLength = minTextLength;
  }

  /**
   * Check if text should be excluded from translation
   */
  shouldExclude(text: string): boolean {
    const trimmed = text.trim();

    // Too short
    if (trimmed.length < this.minTextLength) {
      return true;
    }

    // Check auto-exclude patterns
    if (this.patterns.emails && PATTERNS.email.test(trimmed)) {
      return true;
    }

    if (this.patterns.urls && PATTERNS.url.test(trimmed)) {
      return true;
    }

    if (this.patterns.numbers && PATTERNS.number.test(trimmed)) {
      return true;
    }

    if (this.patterns.phones && PATTERNS.phone.test(trimmed)) {
      return true;
    }

    return false;
  }
}
